export const getUnixTime = () => Math.round(+new Date() / 1000);

// Конвертирует Unix timestamp (секунды) или ISO-строку (UTC) в дату по МСК
export const formatDateMsk = (value) => {
  if (value == null) return '—';
  const ms = typeof value === 'number' ? value * 1000 : Date.parse(value);
  if (isNaN(ms)) return '—';
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(ms));
};
